/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description contains array with collection of error strings and regular expressions to ignore in sentry
 */

export const sentryErrorArray = [
  /^(\[OPTIMIZELY\] - ERROR)( \d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z )(EventProcessor: The operation is insecure\.$)/,
  /^(\[OPTIMIZELY\] - ERROR)( \d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z )(EventProcessor: Failed to read the 'localStorage' property from 'Window': Access is denied for this document\.)$/,
  /^(\[OPTIMIZELY\] - ERROR)( \d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z )(PROJECT_CONFIG: Experiment key [A-Z]+(?:_[A-Z0-9]+)+ is not in datafile.)$/,
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
  'Object Not Found Matching Id',
  "undefined is not an object (evaluating 'n.getAdUnit(e).renderer')",
]

export const denyUrlArray = [/s0.2mdn.net\/instream/]
